import "./AdminExams.css";

import { Exam, TestStatus } from "../../../../model/model";
import { RootState, useAppDispatch, useAppSelector } from "../../../../store";
import {
  getExamAirtableThunk,
  getExamsThunk,
  updateExamThunk,
} from "../../../../store/slices/adminThunks";

import React from "react";
import { adminActions } from "../../../../store/slices/adminSlice";
import { examTransformer } from "./exam.transformer";
import { useNavigate } from "react-router-dom";

export default function AdminExams() {
  const response = useAppSelector(
    (state: RootState) => state.admin.examsResponse
  );
  const questions = useAppSelector((state: RootState) => state.admin.questions);
  const sections = useAppSelector((state: RootState) => state.admin.sections);
  const query = useAppSelector((state: RootState) => state.admin.examsQuery);
  const [exams, setExams] = React.useState<Exam[]>([]);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (response && questions && sections) {
      const exams = response.exams.map((e) =>
        examTransformer.fromFirestore(e, questions, sections)
      );
      setExams(exams);
    }
  }, [response, questions, sections]);

  React.useEffect(() => {
    dispatch(getExamAirtableThunk());
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(getExamsThunk({ query }));
  }, [query, dispatch]);

  const onTestClick = (exam: Exam) => {
    // dispatch(adminActions.setSelectedExam(exam));
    navigate("/admins/grade/" + exam.id);
  };

  const onStatusChange = (exam: Exam, status: TestStatus) => {
    const update = { id: exam.id, status };
    setExams((prevExams) =>
      prevExams.map((e) => (e.id === exam.id ? { ...e, status } : e))
    );
    dispatch(updateExamThunk(update));
  };

  if (!response || !questions || !sections) {
    // style this better
    return <div className="loa-page">Loading...</div>;
  }

  return (
    <div className="loa-page">
      <div className="exam-query">
        <div className="exam-query-item">
          <label htmlFor="status">Status</label>
          <select
            id="status"
            onChange={(evt) => {
              const status = evt.currentTarget.value as TestStatus;
              dispatch(adminActions.setExamsQuery({ status }));
            }}
            value={query?.status}
          >
            <option value="open">Open</option>
            <option value="closed">Closed</option>
            <option value="graded">Graded</option>
            <option value="">All</option>
          </select>
        </div>
      </div>
      <div className="prof-test-grid">
        <div className="header">Email</div>
        <div className="header">Date</div>
        <div className="header">Answers</div>
        <div className="header">No Answers</div>
        <div className="header">Auto Points</div>
        <div className="header">Human Points</div>
        <div className="header">Status</div>
        {exams.map((exam) => {
          return (
            <div className="test-row" key={exam.id}>
              <div
                className="test-item test-email"
                onClick={() => onTestClick(exam)}
              >
                {exam.email}
              </div>
              <div className="test-item">
                {examTransformer.toDate(exam.completedAt)?.toLocaleDateString()}
              </div>
              <div className="test-item">{exam.results?.length}</div>
              <div className="test-item">{exam.noAnswerCount}</div>
              <div className="test-item">{exam.autoPoints}</div>
              <div className="test-item">{exam.humanPoints}</div>
              <div className="test-item">
                {
                  <select
                    onChange={(evt) =>
                      onStatusChange(
                        exam,
                        evt.currentTarget.value as TestStatus
                      )
                    }
                    value={exam.status}
                  >
                    <option value="closed">Closed</option>
                    <option value="open">Open</option>
                    <option value="graded">Graded</option>
                  </select>
                }
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
